import PropTypes from "prop-types";
import { renderEditorAttributeInput } from "./TagAttributeInput.render";
import type { EditorTagAttributeInputProps } from "./tagAttributeInputProps";

// TODO: Consolidate with src/pages/Workspaces/components/TagTypeConfig/TagAttributeInput.js

const TagAttributeInput = (props: EditorTagAttributeInputProps) =>
  renderEditorAttributeInput(props);

TagAttributeInput.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  InputComponent: PropTypes.elementType,
  onSelectAttrValue: PropTypes.func,
  onSelectGroupTypes: PropTypes.func,
  onSelectTagType: PropTypes.func,
  onDateChange: PropTypes.func,
  tagConfig: PropTypes.object,
  formatOptionLabel: PropTypes.func,
  disabled: PropTypes.bool,
  featureFlags: PropTypes.object,
};

export default TagAttributeInput;
